import { DentallyWizardService } from "./../dentally-wizard.service";
import { Component, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { OnInit } from "@angular/core";
import { AuthService } from "../../../../../auth/auth.service";
import { environment } from "../../../../../environments/environment";
import { Observable, from } from "rxjs";
import { AuthMsgService } from "../../../../../auth/auth-msg.service";
import { OrgSettingsService } from "src/org-settings/org-settings.service";
import { ActivatedRoute, Router, Data, ParamMap } from "@angular/router";
import { map } from "rxjs/operators";
import { AppConfigService, AppConfig } from "src/services/app-config.service";
import { InjectHyperlinkPipe } from "../../../pipes/inject-hyperlink.pipe";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { WizardViewModel } from "../wizard-view-model";
import { IntegrationData } from "../IntegrationData";
import { IHasStepNumber } from "src/core/interfaces/IHasStepNumber";
import { MatDialog } from "@angular/material";
import { WelcomeWizardDialog } from "./dialogs/welcome-wizard.dialog";
import * as moment from "moment";
import { IntegrationCustomerStatus } from "../IntegrationCustomerStatus";

@Component({
  selector: "app-dentally-connect",
  templateUrl: "./dentally-connect.component.html",
  styleUrls: ["./dentally-connect.component.scss"],
})
export class DentallyConnectComponent implements OnInit, OnDestroy, IHasStepNumber {
  
  public ShowLoading: boolean = true;
  public ShowWizard: boolean = false;
  public ShowError: boolean = false;
  public wizardData?: WizardViewModel;
  public isCallback: boolean;
  public showModal = true;
  public isWorking: boolean;
  public token: string;
  public state: string;
  public error: string;
  public errorDescription: string;
  public isComplete: boolean = true;
  public config: AppConfig;
  confirmationMessage: any;
  intevalTimer: any;

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private dentallyService: DentallyWizardService,
    private sanitizer: DomSanitizer,
    appConfigService: AppConfigService,
    private router: Router,
    private msgService: AuthMsgService,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {
    this.config = appConfigService.getConfig();
  }
  stepNumber: number = 0;

  public dentallyUrl: string;
  public isAgreed: boolean = false;

  public toNextWizardStep() {
    const nextStepUrl = '/wizard/dentally/learn';
    this.router.navigate([nextStepUrl]);
  }

  public goToNextStep(){
    this.isWorking=true;
    const startCheckingTime = moment();        
    this.intevalTimer = setInterval(() => {
      this.dentallyService.getIntegrationStatus()
        .subscribe((r: IntegrationCustomerStatus) => {
          if (r.status === "Initiated") {
            this.isWorking=false;
            clearInterval(this.intevalTimer);
            this.toNextWizardStep();
          } else if (r.status === "Error") {
            this.error = "An error has occurred. Can not finalize connection. Please contact help@followapp.care.";
            this.errorDescription = `Integration service error. custID ${r.organizationId}`;
            this.isWorking=false;
            clearInterval(this.intevalTimer);
          } else {
            const now = moment();
            if (now.diff(startCheckingTime, "minutes") > 3) {
              this.error = "An error has occurred. Can not finalize connection. Please contact help@followapp.care.";
              this.errorDescription = `Integration service error. custID ${r.organizationId}`;
              this.isWorking=false;
              clearInterval(this.intevalTimer);
            }
          }
        }, (err) => {
          this.error = "An error has occurred. Can not finalize connection. Please contact help@followapp.care.";
          this.errorDescription = `Integration service error. wizID ${this.wizardData.id}`;
          this.isWorking=false;
          clearInterval(this.intevalTimer);
        });
    }, 3000);
  }

  ngOnInit(): void {
    this.authService.getClaims$().subscribe(() => {
      this.initAfterGetClaims();
    });
  }

  private initAfterGetClaims() {
    this.getWizardState()
      .subscribe(state => {
        if (state.data.step === "Authorization") {
          state.data.step = "Introduction";
          this.dentallyService.updateWizardStep(state)
            .subscribe((s) => {
              this.initiateConnectComponent();
            });
        } else if (state.data.step === "LearnHow") {
          this.router.navigateByUrl("/wizard/dentally/learn");
        } else if (state.data.step === "Start") {
          this.router.navigateByUrl("/wizard/dentally/start");
        } else {
          this.initiateConnectComponent();
        }
      });
  }

  onCopyToClipboardClick(inputElement) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = inputElement.innerText;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  onRetryClick() {
    this.router.navigate(["/wizard/dentally/connect"], { queryParams: { modal: false } });
  }

  private initiateConnectComponent() {
    const confirmationMessageKey =
      "dentally_wizard.wizard_start_confirmation_message";
    this.translate.stream(confirmationMessageKey).subscribe((val) => {
      if (val !== confirmationMessageKey) {
        this.confirmationMessage = new InjectHyperlinkPipe(
          this.sanitizer
        ).transform(val, "https://followapp.care/dentally", "_blank");
      }
      this.ShowLoading = false;
      this.ShowWizard = true;
    });
    this.msgService.sendMessage(this.authService.isLoggedIn());
    const params = this.route.snapshot.queryParamMap;   
    this.route.data.subscribe((d) => this.handleRouteData(d, params));
    this.dentallyService.getWizardState().subscribe((r) => {
      this.wizardData = r;
      this.trySetDentallyUrl();
    });
  }

  getWizardState(): Observable<WizardViewModel> {
    var state$ = new Observable<WizardViewModel>((subscriber) => {
      this.dentallyService.getWizardState().subscribe((state) => {
        subscriber.next(state);
      });
    });
    return state$;
  }

  handleRouteData(d: Data, params: ParamMap) {
    this.isCallback = d.isCallback || false;
    this.showModal = params.has("modal") ? params.get("modal") === 'true' : true;
    if (this.isCallback) {
      this.isWorking = true;
      this.route.queryParams.subscribe((parms) => {
        this.error = parms.error;
        this.errorDescription = parms.error_description;
        this.token = parms.code;
        this.state = parms.state;
        if (this.token && this.state && !this.error) {
          this.dentallyService.getWizardState().subscribe((d) => {
            this.wizardData = d;
            if (!this.wizardData || this.state != this.wizardData.id) {
              this.error = this.wizardData ? "state_mismatch" : "no_state";
              this.errorDescription = this.wizardData
                ? "state value did not match the stored wizard id"
                : "no wizard data was stored";
            } else {
              if (!this.wizardData.data)
                this.wizardData.data = new IntegrationData();
              this.wizardData.data.code = this.token;
              this.wizardData.data.step = "Authorization";
              this.dentallyService.updateWizardStep(this.wizardData).subscribe(
                (response) => {
                  if (response.errors && response.errors.length) {
                    this.error = "An error has occurred. Please contact help@followapp.care quoting this reference info";
                    this.errorDescription = response.errors[0];
                    response.errors = response.errors.slice(1);
                  }
                  this.wizardData = response;
                  this.isWorking = false;
                  this.isComplete = true;                 
                },
                (err) => {
                  console.error(err);
                  this.error = "An error has occurred. Please contact help@followapp.care quoting this reference info";
                  this.errorDescription = err.message;
                }
              );
            }
          });
        }
      });
    } else if (this.showModal) this.dialog.open(WelcomeWizardDialog);
    
  }

  private trySetDentallyUrl() {
    if (
      !this.wizardData ||
      this.wizardData.complete ||
      this.wizardData.type !== "Dentally"
    ) {
      this.error = "no_wizard";
      this.errorDescription = "this user has no incomplete wizard";
    } else {
      this.setDentallyUrl();
    }
  }

  private setDentallyUrl() {
    const clientId = this.config.dentally_client_id;
    const redirectUri = `https://${window.location.hostname}${
      window.location.port ? ":" + window.location.port : ""
      }/wizard/dentally/callback`;
    const scope = this.config.dentally_scopes;
    const state = this.wizardData ? this.wizardData.id : "";
    this.dentallyUrl = `${
      this.config.dentally_integration_url
      }oauth/authorize?client_id=${encodeURIComponent(
        clientId
      )}&redirect_uri=${encodeURIComponent(
        redirectUri
      )}&scope=${encodeURIComponent(
        scope
      )}&response_type=code&state=${encodeURIComponent(state)}`;
  }

  ngOnDestroy(): void {
    if (this.intevalTimer) {
      clearInterval(this.intevalTimer);
    }
  }
}
